import useReactHookForm from "hooks/useReactHookForm";

import { useAppDispatch, useAppSelector } from "hooks/redux";
import { Button, Grid, Paper } from "@mui/material";
import DynamicForm from "shared/organisms/dynamicform";
import ContentRight from "shared/molecules/content-right";
import {
  courseClassSubChapMapInitialValues,
  courseClassSubChapMapMandatoryFields,
  courseClassSubChapMapProperties,
  courseClassSubChapMapValidationSchema,
} from "./helper";
import { TypographyHeading } from "shared/molecules/typography-layout";
import { useMutation } from "@apollo/client";
import entitesClient from "utils/graphql/entitiesClient";

import { isEmpty } from "utils/helpers";
import { snackbarRequest } from "shared/molecules/snackbar/snackbar-slice";
import { useHistory } from "react-router-dom";
import { isFieldsValidate } from "shared/organisms/dynamicform/helper";
import LoadingButton from "@mui/lab/LoadingButton";

import {

  CREATE_COURSE_CLASS_SUBJECT_CHAPTER_MAPPING,
} from "utils/graphql/services/global-content-hierarchy/mutation";


export const CourseClassSubChapMapCreate = () => {
  const { control, errors, getValues, watch, setValue } = useReactHookForm(
    courseClassSubChapMapInitialValues,
    courseClassSubChapMapValidationSchema,
    ""
  );
  const [createCourseClassSubjectChapterMapping, { loading, error, data }] =
    useMutation(CREATE_COURSE_CLASS_SUBJECT_CHAPTER_MAPPING, {
      client: entitesClient,
    });
    
  const dispatch = useAppDispatch();
  const history = useHistory();

  const handleCreateCourseClassSubChapMap = async () => {
    try {
      const response: any = await createCourseClassSubjectChapterMapping({
        variables: {
          input: {
            status: watch()?.status,
            global_course_id: watch()?.global_course_id,
            global_subject_id: watch()?.global_subject_id,
            global_chapter_id: watch()?.global_chapter_id,       
            is_course_hierarchy_enabled:
              watch()?.is_course_hierarchy_enabled == "true" ? true : false,
            is_program_hierarchy_enabled:
              watch()?.is_program_hierarchy_enabled == "true" ? true : false,
            class_id: watch()?.class_id,
          },
        },
      });
      if (
        !isEmpty(
          response?.data?.createCourseClassSubjectChapterMapping?.success
        )
      ) {
        dispatch(
          snackbarRequest({
            message:
              `${response?.data?.createCourseClassSubjectChapterMapping?.message}` ||
              `Created Course Class Subject Chapter Map successfully`,
          })
        );
        history.replace(
          `/global-content-hierarchy/course_class_sub_chap_map`
        );
      } else {
        dispatch(
          snackbarRequest({
            message:
              `${response?.data?.createCourseClassSubjectChapterMapping?.message}` ||
              `failed to create Course Class Subject Chapter Map`,
            type: "error",
          })
        );
      }
    } catch (err: any) {
      dispatch(
        snackbarRequest({
          message:
            `${err?.message}` ||
            `failed to create Course Class Subject Chapter Map`,
          type: "error",
        })
      );
    }
  };

  return (
    <div>
      <TypographyHeading>
        Create Course Class Subject Chapter Mapping
      </TypographyHeading>
      <Paper elevation={2} sx={{ px: 2, pb: 2, pt: 2 }}>
        <Grid container spacing={2}>
          <DynamicForm
            fields={courseClassSubChapMapProperties}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            watch={watch}
          />
          <ContentRight sx={{ mt: -7 }}>
            <LoadingButton
              variant="contained"
              loadingPosition="start"
              sx={{
                width: "200px",
                height: "40px",
                marginTop: "15px",
                marginRight: "10px",
                padding: "7px 23.5px 7px 23.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={handleCreateCourseClassSubChapMap}
              disabled={!isFieldsValidate(errors, courseClassSubChapMapMandatoryFields, getValues)}
              loading={loading}
            >
              Create
            </LoadingButton>
          </ContentRight>
        </Grid>
      </Paper>
    </div>
  );
};
